/* PLTÉ Maison · motion-laag (WS-MOTION, contract C8): cross-document View Transitions.
   Vervangt de JS-fade van 300 ms. Root uit .26 s / in .48 s (CSS in plte-motion.css), header stil (hdr),
   beeldmorf hero-shot van kaart of swatch naar de PDP-galerij. Overslaan bij Motion · off, minder beweging,
   de Threshold, een open lade of overlay, en op weg naar checkout, mand of account; wie tijdens de fade klikt
   of typt, wacht niet. Firefox en Samsung Internet kennen pageswap/pagereveal niet en navigeren direct. */
(function () {
  'use strict';
  var P = window.PLTE = window.PLTE || {}, S = P.settings || {}, html = document.documentElement;
  var src = null, named = null, tm;
  function off() {
    return S.transitions === false || html.hasAttribute('data-motion-off') || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function overlayOpen() {
    return !!document.querySelector('[data-cart-drawer].is-open,[data-menu].is-open,[data-search].is-open,[data-quiz].is-open');
  }
  function clear() {
    if (named) { named.style.removeProperty('view-transition-name'); named = null; }
    html.classList.remove('vt-src'); src = null;
  }
  /* bron van de beeldmorf: kaart of paneelkaart → eigen beeld; swatch → de huidige PDP-galerij (kleur naar kleur) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.card__media,[data-vt-source]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button || a.target === '_blank') return;
    src = a.querySelector('.media') || document.querySelector('.pdp__shot--vt .media') || null;
    /* vangnet: een klik die niet tot navigatie leidt, mag geen morfbron achterlaten */
    clearTimeout(tm); tm = setTimeout(function () { src = null; }, 1500);
  });
  window.addEventListener('pageswap', function (e) {
    var vt = e.viewTransition, s = src; src = null; clearTimeout(tm); if (!vt) return;
    var url = (e.activation && e.activation.entry && e.activation.entry.url) || '';
    var open = overlayOpen();
    if (P.cart && P.cart.close) P.cart.close();
    if (off() || open || /\/(checkouts?|cart|account)(\/|$|\?|#)/.test(url)) { vt.skipTransition(); return; }
    if (s && s.isConnected) {
      /* één element met de naam: de galerij van de huidige pagina geeft hem af aan de bron */
      html.classList.add('vt-src'); named = s; s.style.viewTransitionName = 'hero-shot';
    }
  });
  window.addEventListener('pagereveal', function (e) {
    var vt = e.viewTransition; if (!vt) return;
    if (off() || html.classList.contains('threshold-active')) { vt.skipTransition(); return; }
    var skip = function () { vt.skipTransition(); };
    document.addEventListener('pointerdown', skip, { once: true });
    document.addEventListener('keydown', skip, { once: true });
    var done = function () { document.removeEventListener('pointerdown', skip); document.removeEventListener('keydown', skip); };
    vt.finished.then(done, done);
  });
  /* terug uit de bfcache: inline naam en klasse weer weg */
  window.addEventListener('pageshow', clear);
})();
